'use client'

import cn from 'clsx'

import type { Gallery as GalleryType } from '../../../../../apps/benmax/src/types/sanity.types'

import ImageSlider from '../../ImageSlider/ImageSlider'

import s from './Gallery.module.sass'

function Gallery({ title, gallery }: GalleryType) {
    return (
        <section className={s.Gallery}>
            <div className={cn(s.Cont, 'container')}>
                {title && <h2 dangerouslySetInnerHTML={{ __html: title }} />}
                {gallery && (
                    <div className={s.Main}>
                        <ImageSlider
                            breakpoints={{
                                1024: {
                                    slidesPerView: 2,
                                    spaceBetween: 15,
                                },
                                1280: {
                                    slidesPerView: 2.5,
                                    spaceBetween: 20,
                                },
                            }}
                            items={gallery}
                        />
                    </div>
                )}
            </div>
        </section>
    )
}

export default Gallery
